import React from 'react'
import * as NUMBER from 'common/constant/numbers'
import * as ROUTES from 'constant/routes'
import * as AUTH_ACTION from 'common/constant/actions/auth'
import * as LOGIN_TYPE from 'common/constant/login-type'
import { notification } from 'antd'
import { ClockCircleTwoTone } from '@ant-design/icons'
import { createAction } from 'redux-actions'
import { createBrowserHistory } from 'history'

const updateAuthState = createAction(AUTH_ACTION.UPDATE_AUTH_STATE)

let sessionTimerId
let alertTimeoutId
const history = createBrowserHistory()
// eslint-disable-next-line complexity
export const isLoggedIn = (location) => async (dispatch, getState, { auth }) => {
  try {
    const response = await auth.isLoggedIn()
    dispatch(updateAuthState({ loginCheckComplete: true }))
    if (response && response.success) {
      const user = response.user
      startSessionTimer(dispatch)
      listenForRouteChange(dispatch)
      dispatch(qlikAuth())
      dispatch(updateAuthState({ isAuthenticated: true, user }))
      history.replace(location?.state?.from)
    }
  } catch (error) {
    console.error(error)
    dispatch(updateAuthState({ loginCheckComplete: true }))
  }
}

export const login = (credentials) => async (dispatch, getState, { auth }) => {
  try {
    // dispatch(updateLoginSubmitting(true))
    const { url } = await auth.login({ ...credentials, login_type: LOGIN_TYPE.EXTERNAL })
    dispatch(updateAuthState({ loginCheckComplete: false }))
    sessionStorage.setItem('qlik', 'true')
    window.location.href = url
  } catch (error) {
    console.error(error)
  }
}

export const qlikAuth = () => async (dispatch, getState, { auth }) => {
  try {
    if (!sessionStorage.getItem('qlik')) {
      const {
        auth: authState
      } = getState()
      const { url } = await auth.qlikAuth({ user: authState.user })
      sessionStorage.setItem('qlik', 'true')
      window.location.href = url
    }
  } catch (error) {
    console.error(error)
  }
}

const listenForRouteChange = (dispatch) => {
  history.listen((location) => {
    if (history.location.pathname !== ROUTES.LOGIN) {
      startSessionTimer(dispatch)
    }
  })
}

const openNotificationWithIcon = (type) => {
  notification.open({
    description:
      'Your session will expire in 2 minutes.',
    duration: NUMBER.ONE_HUNDRED_TWENTY,
    icon: <ClockCircleTwoTone style={{ color: '#490C4E' }} />,
    message: 'Session Expiry'
  })
}

const logoutNotification = (type) => {
  notification.open({
    description:
      'Your session expired due to inactivity.',
    duration: NUMBER.ZERO,
    icon: <ClockCircleTwoTone twoToneColor='#7f2fd1' />,
    message: 'Session Expiry'
  })
}

const startAlertTimer = () => {
  if (alertTimeoutId !== undefined) {
    clearTimeout(alertTimeoutId)
  }

  alertTimeoutId = setTimeout(() => {
    openNotificationWithIcon('info')
  }, NUMBER.FIFTY_EIGHT_MINUTES)
}

const startSessionTimer = (dispatch) => {
  startAlertTimer()
  if (sessionTimerId !== undefined) {
    clearTimeout(sessionTimerId)
  }

  sessionTimerId = setTimeout(() => {
    dispatch(logout())
    logoutNotification('info')
  }, NUMBER.ONE_HOUR)
}

export const logout = () => async (dispatch, getState, { auth }) => {
  try {
    dispatch(updateAuthState({ loginCheckComplete: false }))

    await auth.logout()
    dispatch(updateAuthState({ isAuthenticated: false, loginCheckComplete: true, user: undefined }))
    history.push('/')
  } catch (error) {
    dispatch(updateAuthState({ isAuthenticated: false, loginCheckComplete: true, user: undefined }))
  }
}
